import Button from '../button/Button';
import './TopicBlock.scss'

interface TopicBlockProps {
  btnTitle?: string,
  style?: any,
  darkTheme?: boolean,
  children?: any,
}

const TopicBlock = (props: TopicBlockProps) => {
  return (
    <div className={'topic-block' + (props.darkTheme ? ' dark' : '')} style={props.style}>
      {props.children}
      {props.btnTitle && props.btnTitle.length > 0 && (
        <Button title={props.btnTitle} />
      )}
    </div>
  );
};

export default TopicBlock